import { useFeatureFlag } from "@harnessio/ff-react-client-sdk";

export const UsersDirectoryMenuFlag = () => {
  return useFeatureFlag("Users_Directory_Menu");
};

export const OwnersDirectoryMenuFlag = () => {
  return useFeatureFlag("Ownership_Directory_Menu");
};

export const TenantDirectoryMenuFlag = () => {
  return useFeatureFlag("Tenant_Directory_Menu");
};

export const VendorDirectoryMenuFlag = () => {
  return useFeatureFlag("Vendor_Directory_Menu");
};

export const MaintenanceTechDirectoryMenuFlag = () => {
  return useFeatureFlag("Maintenance_Technician_Directory");
};
